import * as DESTINATION from "store/constants/destinations";
const DESTINATIONS = {
  [DESTINATION.KOMODO]: "/labuan-bajo/komodo/",
  [DESTINATION.BALI]: "https://www.ayana.com/bali/",
  [DESTINATION.CRUISE]: "/labuan-bajo/lakodia",
  [DESTINATION.JAKARTA]: "/jakarta/ayana-midplaza-jakarta",
};

export default DESTINATIONS;
